export default __webpack_public_path__ + "static/media/Checkers_Demo_2.30b1dc78.PNG";